import { connect } from 'react-redux';
import { push } from 'react-router-redux/lib/actions';
import CityEventsRoot from './CityEventsRoot';
import { fetch, save, updateCmsEditor } from '../../../actions/city_events';

import {ROUTE_EVENTS_ROOT} from '../constants';


export default connect(
  (state) => {
    const { city_events: { cmsEditorState, loading } } = state
    return {
    cmsEditorState,
    loading
  }
  },
  (dispatch) => ({
    updateCmsEditor: (data) => dispatch(updateCmsEditor(data)),
    loadCMSEditor: () => dispatch(fetch()),
    save: (data) => {
      dispatch(save(data))
      dispatch(push(ROUTE_EVENTS_ROOT))
    }
  })
)(CityEventsRoot);



// WEBPACK FOOTER //
// ./src/components/CityEvents/CityEventsRoot/index.js